import { z } from 'zod';

import { OptionalPhoneNumber } from '../../../Phone';
import { OptionalEmailString } from '../../email';
import { AddressLine, Checkbox, DateString, NonNegativeMonetaryValue } from '../../fields';

const SingleInsuranceFields = z.object({
  isEscrowed: Checkbox.optional(),
  amount: NonNegativeMonetaryValue.optional(),
  coverageAmount: NonNegativeMonetaryValue.optional(),
  agentName: z.string().optional(),
  agentEmail: OptionalEmailString,
  agentPhone: OptionalPhoneNumber,
  companyName: z.string().optional(),
  companyAddressLine1: AddressLine.optional(),
  companyAddressLine2: AddressLine.optional(),
  companyAddressCity: z.string().optional(),
  companyAddressState: z.string().optional(),
  companyAddressZip: z.string().optional(),
  policyNumber: z.string().optional(),
  policyStart: DateString.optional(),
  policyEnd: DateString.optional(),
  forcedPlacedFlag: Checkbox.optional(),
});

const SinglePropertyInsuranceFields = z.object({
  hazard: SingleInsuranceFields.optional(),
  homeowners: SingleInsuranceFields.optional(),
  flood: SingleInsuranceFields.optional(),
  windstorm: SingleInsuranceFields.optional(),
  hurricane: SingleInsuranceFields.optional(),
  fire: SingleInsuranceFields.optional(),
  liability: SingleInsuranceFields.optional(),
  rental: SingleInsuranceFields.optional(),
  condo: SingleInsuranceFields.optional(),
  earthquake: SingleInsuranceFields.optional(),
  umbrella: SingleInsuranceFields.optional(),
  sinkhole: SingleInsuranceFields.optional(),
  wildfire: SingleInsuranceFields.optional(),
  sewer: SingleInsuranceFields.optional(),
  equipment: SingleInsuranceFields.optional(),
  title: SingleInsuranceFields.optional(),
  other: SingleInsuranceFields.optional(),
});

export const PrimaryPropertyInsuranceFields = z.object({
  address1Insurance: SinglePropertyInsuranceFields.optional(),
});

export const MultiPropertyInsuranceFields = z.object({
  address2Insurance: SinglePropertyInsuranceFields.optional(),
  address3Insurance: SinglePropertyInsuranceFields.optional(),
  address4Insurance: SinglePropertyInsuranceFields.optional(),
  address5Insurance: SinglePropertyInsuranceFields.optional(),
  address6Insurance: SinglePropertyInsuranceFields.optional(),
  address7Insurance: SinglePropertyInsuranceFields.optional(),
  address8Insurance: SinglePropertyInsuranceFields.optional(),
  address9Insurance: SinglePropertyInsuranceFields.optional(),
  address10Insurance: SinglePropertyInsuranceFields.optional(),
  address11Insurance: SinglePropertyInsuranceFields.optional(),
  address12Insurance: SinglePropertyInsuranceFields.optional(),
  address13Insurance: SinglePropertyInsuranceFields.optional(),
  address14Insurance: SinglePropertyInsuranceFields.optional(),
  address15Insurance: SinglePropertyInsuranceFields.optional(),
});
